import "react-grid-layout/css/styles.css";
import { useState } from "react";
import { DashboardContext } from "./context";
import { DashboardWrapper } from "./dashboard-wrapper";
import type { DashboardProps } from "./shared";

export function Dashboard({ children, ...props }: DashboardProps) {
	/** State */
	const [layouts] = useState(props.layouts);

	if (!layouts) return null;

	/** Render */
	return (
		<DashboardContext.Provider value={{ layouts }}>
			{children}
			<DashboardWrapper {...props}>
				{layouts?.lg.map((item) => (
					<div key={item.i}>{props.render(item)}</div>
				))}
			</DashboardWrapper>
		</DashboardContext.Provider>
	);
}
